'use client'

import { useEffect } from 'react'

export function PwaInstallability() {
  useEffect(() => {
    if (!('serviceWorker' in navigator) || !window.isSecureContext) return
    if (navigator.userAgent.includes('MartiniDesktop')) return

    let cancelled = false
    const register = () => {
      if (cancelled) return
      navigator.serviceWorker.register('/sw.js').catch(() => {
        // Installability should never block app startup.
      })
    }

    if (document.readyState === 'complete') {
      register()
    } else {
      window.addEventListener('load', register, { once: true })
    }

    return () => {
      cancelled = true
      window.removeEventListener('load', register)
    }
  }, [])

  return null
}
